import * as React from 'react';
import styled from 'styled-components';
import Slider from 'components/ui/Slider(new)';

export default function DiscreteSlider({
  value,
  min = 1,
  max = 10,
  marks = [],
  withThumb = true,
}) {
  return <Slider min={min} max={max} marks={marks} withThumb={withThumb} />;
}
